import type { PopulationBlob } from './blobLoader';

export function ageBandLabel(blob: PopulationBlob | null, id: number): string {
  const def = blob?.ageBands.find((b) => b.id === id);
  return def?.label ?? `band ${id}`;
}

export function incomeBandLabel(blob: PopulationBlob | null, id: number): string {
  const def = blob?.incomeBands.find((b) => b.id === id);
  return def ? `Band ${def.id}: ${def.label}` : `Band ${id}`;
}
